import { Reveal } from "./Reveal";

const SectionHead = ({ id, eyebrow, title, intro }) => (
  <div className="section-heading">
    <Reveal>
      <p className="eyebrow">{eyebrow}</p>
      <h2>{title}</h2>
    </Reveal>
    {intro && (
      <Reveal delay={0.15}>
        <p className="section-intro">{intro}</p>
      </Reveal>
    )}
  </div>
);

export default SectionHead;
